import React, { FC } from 'react'
import styles from './ArticleHeader.module.scss'
import Author from 'components/author/Author'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from 'react-share'
import { ArticleHeaderProps as Props } from '../types'
import Tag from 'components/tag/Tag'

const ArticleHeader: FC<Props> = ({ author, messageShareText, tag, tagColor, title }) => {
  const url = typeof window !== 'undefined' ? window.location.href : ''

  return (
    <section className={styles['article-header']}>
      {tagColor ? <Tag name={tag} color={tagColor} /> : <div className={styles.tag}>{tag}</div>}
      <h1>{title}</h1>
      <div className={styles['meta-container']}>
        <Author {...author} />

        <div className={styles['socials-container']}>
          <FacebookShareButton className={styles['button-share']} resetButtonStyle={false} url={url} quote={messageShareText || title}>
            <FacebookIcon size={20} bgStyle={{ fill: 'none' }} />
            Share
          </FacebookShareButton>
          <EmailShareButton className={styles['button-share']} resetButtonStyle={false} url={url} body={messageShareText || title}>
            <EmailIcon size={20} bgStyle={{ fill: 'none' }} />
            Mail
          </EmailShareButton>
          <TwitterShareButton className={styles['button-share']} resetButtonStyle={false} url={url} title={messageShareText || title}>
            <TwitterIcon size={20} bgStyle={{ fill: 'none' }} />
            Tweet
          </TwitterShareButton>
          <WhatsappShareButton className={styles['button-share']} resetButtonStyle={false} url={url} title={messageShareText || title}>
            <WhatsappIcon size={20} bgStyle={{ fill: 'none' }} />
            App
          </WhatsappShareButton>
        </div>
      </div>
    </section>
  )
}

export default ArticleHeader
